import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { useAlerts } from '../contexts/AlertsContext';
import departmentService from '../services/departmentService';
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [chiefDepartment, setChiefDepartment] = useState(null);
  const [loadingDept, setLoadingDept] = useState(false);
  const { isLoggedIn, isAdmin, user, hasRole, logout } = useAuth();
  const { addToast } = useToast();
  const { myAlerts, nearbyAlerts } = useAlerts();
  const navigate = useNavigate();
  const location = useLocation();

  const unreadCount = [...myAlerts, ...nearbyAlerts].filter(a => a.status === 'active').length;

  useEffect(() => {
    if (!isLoggedIn || !hasRole('department_chief')) {
      setChiefDepartment(null);
      return;
    }

    let cancelled = false;
    setLoadingDept(true);
    departmentService.listDepartments()
      .then((data) => {
        if (cancelled) return;
        const owned = (data.departments || []).find((d) => d.chief_user_id === user?.id);
        setChiefDepartment(owned || null);
      })
      .catch(() => {
        if (!cancelled) setChiefDepartment(null);
      })
      .finally(() => {
        if (!cancelled) setLoadingDept(false);
      });

    return () => { cancelled = true; };
  }, [isLoggedIn, hasRole, user, location.pathname]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu  = () => setIsMenuOpen(false);

  const handleLogout = async () => {
    closeMenu();
    await logout();
    addToast('You have been logged out.', 'success');
    navigate('/');
  };

  return (
    <header className="header">
      <div className="logo">
        <img src="/logo-sm.png" alt="Herding Helpers Logo" />
        Herding Helpers
      </div>
      
      <button 
        className="hamburger-button"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>




      <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
        <ul>
            {isLoggedIn && (
              <>
                              <li>
                <Link to="/profile" onClick={closeMenu} className="nav-item">
                  <span className="material-icons nav-icon">account_circle</span>
                  Profile
                </Link>
                </li>
                <li>
                  <Link to="/dashboard" onClick={closeMenu} className="nav-item">
                    <span className="material-icons nav-icon">dashboard</span>
                    Dashboard
                  </Link>
                </li>
                {isAdmin && (
                  <li>
                    <Link to="/admin" onClick={closeMenu} className="nav-item">
                      <span className="material-icons nav-icon">admin_panel_settings</span>
                      Admin Portal
                    </Link>
                  </li>
                )}
                {isLoggedIn && hasRole('department_chief') && !loadingDept && (
                  <>
                    <li>
                      <Link
                        to={chiefDepartment ? `/departments/${chiefDepartment.id}` : '/setup/department'}
                        onClick={closeMenu}
                        className="nav-item"
                      >
                        <span className="material-icons nav-icon">local_fire_department</span>
                        {chiefDepartment ? 'My Department' : 'Set Up Department'}
                      </Link>
                    </li>
                    {chiefDepartment && (
                      <li>
                        <Link to="/alerts-department-log" onClick={closeMenu} className="nav-item">
                          <span className="material-icons nav-icon">assignment</span>
                          Department Alert Log
                        </Link>
                      </li>
                    )}
                  </>
                )}
                {isLoggedIn && !isAdmin && (
                  <li>
                    <Link to="/join-department" onClick={closeMenu} className="nav-item">
                      <span className="material-icons nav-icon">group_add</span>
                      Join Department
                    </Link>
                  </li>
                )}
                <li>
                  <Link to="/alerts" onClick={closeMenu} className="nav-item nav-item--bell">
                    <span className="material-icons nav-icon nav-icon--bell">
                      {unreadCount > 0 ? 'notifications' : 'notifications_none'}
                    </span>
                    {unreadCount > 0 && (
                      <span className="nav-badge">{unreadCount}</span>
                    )}
                    Alerts
                  </Link>
                </li>
                <li>
                  <Link to="/alerts-log" onClick={closeMenu} className="nav-item">
                    <span className="material-icons nav-icon">history</span>
                    Alert Log
                  </Link>
                </li>
              </>
            )}
            {isLoggedIn ? (
              <li>
                <button onClick={handleLogout} className="logout-button nav-item">
                  <span className="material-icons nav-icon">logout</span>
                  Logout
                </button>
              </li>
            ) : (
              <>
                <li><Link to="/login" onClick={closeMenu}>Login</Link></li>
                <li><Link to="/create-account" onClick={closeMenu}>Create Account</Link></li>
              </>
            )}
        </ul>
      </nav>
    </header>
  );
}

export default Header;
